define([
    "./microstrategyModule"
], function (module) {
    "use strict";

    return module.service("microstrategyService", [
        "microstrategyServiceUrl",
        "$http",
        function (microstrategyServiceUrl, $http) {
            var MICROSTRATEGY_AUTH_TOKEN_STORAGE_KEY = "microstrategyAuthToken";

            function storeMicrostrategyAuthToken(authToken) {
                localStorage.setItem(MICROSTRATEGY_AUTH_TOKEN_STORAGE_KEY, authToken);
            }

            function clearCache() {
                var authToken = localStorage.getItem(MICROSTRATEGY_AUTH_TOKEN_STORAGE_KEY);
                if (authToken) {
                    $http.post(microstrategyServiceUrl.logoutUrl, authToken);
                }
            }

            function renewSession() {
                var authToken = localStorage.getItem(MICROSTRATEGY_AUTH_TOKEN_STORAGE_KEY);
                if (authToken) {
                    $http.post(microstrategyServiceUrl.renewSessionUrl, authToken);
                }
            }

            return {
                clearCache: clearCache,
                storeMicrostrategyAuthToken: storeMicrostrategyAuthToken,
                renewSession:renewSession
            };
        }]);
});